import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\src\\modules\\privacy-policy\\template\\index.js");
